import React, {useEffect, useState} from "react";
import Header from "../components/Header.js";
import * as AccountService from "../services/AccountService.js";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import * as StorageService from "../services/StorageService";
import CampaignCard from "../components/CampaignCard";
import {PATH} from "../routes/routes.js";
import analyticsLogEvent from "../services/FirebaseService";
import {getAllCampaigns} from "../util/common";
import {FormattedMessage} from "react-intl";
import {useLocation, useNavigate} from "react-router";

function Main() {
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";


    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();

    const refUrl = query.get('refUrl');

    const [state, setState] = useState({
        currentStyle:hidden,
        allCampaigns:[],
        allLinkCampaigns: [],
        shopDetails: null,
        continueInBrowser: StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) ? (StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) + "") === "true" : false
    });

    const openModal = () => {
        setState({
            ...state,
            currentStyle: visible
        })
    }
    const closeModal = () => {
        setState({
            ...state,
            currentStyle: hidden
        })
    }

    useEffect(() => {
        StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART); // SAME AS ON MOBILE
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.RESTAURANT,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.RESTAURANT
        });
    }, []);
    //todo check if this approach works
    useEffect(() => {

        const handlePopstate = () => {
            if (window.history.state && window.history.state.action === 'POP') {
                navigateTo({
                    pathname:PATH.MAIN,
                    replace:true
                });
            }
        };

        window.addEventListener('popstate', handlePopstate);

        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, [navigateTo]);



    useEffect(  () => {
        getPageContent();
    }, []);

    const getPageContent = async () => {
        let shopDetails = null;
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
            await AccountService.configApp();
            shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));
        } else {
            return;
        }


        const allCampaignsResponse = await getAllCampaigns(shopDetails.name);

        setState(prev => {
            return {
                ...prev,
                allCampaigns: allCampaignsResponse,
                shopDetails: shopDetails,

            };
        });
    }



    const chooseOrderingMethod = (method) => {
        StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, method);
        if (method === ORDER_PLACE.TABLE) {
            //TODO useNavigate with search params
            navigateTo({
                pathname:  PATH.ALL_PRODUCTS,
                search: "?readonly=true"
            });
        }else {
            navigateTo(PATH.ALL_PRODUCTS);
        }
    }

    const groupCampaignsByTags = (campaigns) => {
        const groups = {};
        campaigns.forEach(campaign => {
            const tag = campaign.tags[0] || "Other";
            if (!groups[tag]) {
                groups[tag] = [];
            }
            groups[tag].push(campaign);
        });
        return groups;
    };

    const groupedCampaigns = state.shopDetails?.type === 2 ? groupCampaignsByTags(state.allCampaigns) : null;
    return (
        <>
            <Header
                headerSize={HEADER_SIZE.BIG}
                shopDetails={state.shopDetails}
                hasBackgroundImg={true}
                headerTitle={state.shopDetails?.title}
                hasModal={true}

                refUrl={refUrl}
                hasProfileBtn={true}
                hasShopInfoIcon={true}
                isMainPage={true}
                hasBackBtn={false}
            />
            <div className={state.currentStyle+" modal-overlay "} onClick={(e)=> closeModal()}>   </div>
            <div className="modal bigger">
                <div className="row">
                    <div className="modal-title"><FormattedMessage id="OrderingMethod"/></div>
                </div>

                <div className="row buttons-row">
                    <a className=" btn btn-outlined btn-md" id="tableOrdering"  onClick={() => chooseOrderingMethod(ORDER_PLACE.TABLE)}><FormattedMessage id="TableOrdering"/></a>
                    <a className="btn btn-outlined btn-md" id="counterPickup" onClick={() => chooseOrderingMethod(ORDER_PLACE.BAR)}><FormattedMessage id="CounterPickup"/></a>
                </div>
            </div>
            {
                state.allCampaigns && state.allCampaigns.length > 0 ?
                    <section className="link-campaigns-container">
                        <div className={`all-link-campaigns-list ${state.shopDetails?.type === 2 ? "grouped-campaigns-list" : ""}`}>
                            <>
                                {state.shopDetails?.type === 2 ? ( //MICRO UNIVERSE
                                    Object.entries(groupedCampaigns).map(([tag, campaigns]) => (
                                        <div key={tag} className="campaign-group">
                                            <h2 className="campaign-group-title">{tag}</h2>
                                            <div className="campaign-group-list">

                                                {campaigns.map((campaign, index) => (
                                                    <CampaignCard
                                                        key={campaign.name}
                                                        campaign={campaign}
                                                        isLinkCampaign={campaign.link? true: false}
                                                        openModal={openModal}
                                                        closeModal={closeModal}
                                                    />
                                                ))}

                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    state.allCampaigns.map((campaign, index) => (
                                        <CampaignCard
                                            key={campaign.name}
                                            campaign={campaign}
                                            isLinkCampaign={campaign.link? true: false}
                                            openModal={openModal}
                                            closeModal={closeModal}
                                        />
                                    ))
                                )}
                            </>
                        </div>
                    </section>
                    : null
            }
        </>

    );
}

export default Main;
